import Button from "@pathwright/ui/src/components/button/Button"
import PropTypes from "prop-types"
import "./ContentMethodFormWrapper.css"

// Provides <form> to wrap children, and <footer> area with general actions.

const ContentMethodFormWrapper = function (
  { children, onSubmit, className },
  { exitEditor }
) {
  if (className == null) {
    className = ""
  }
  className += " ContentMethod__FormWrapper"

  return (
    <form className={className}>
      {children}
      <footer>
        <Button styleType="blank" onClick={exitEditor}>{`\
Cancel\
`}</Button>
        <Button onClick={onSubmit}>{`\
Save \& Publish\
`}</Button>
        <aside>{`\
Changes will be live everywhere this content is used.\
`}</aside>
      </footer>
    </form>
  )
}

ContentMethodFormWrapper.displayName = "ContentMethodFormWrapper"

ContentMethodFormWrapper.contextTypes = { exitEditor: PropTypes.func }

export default ContentMethodFormWrapper
